import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Beforeunload } from "react-beforeunload";
import logo from "../Assets/bg.jpg";

import { Layout, Menu, Card, List } from "antd";
import {
  PieChartOutlined,
  DesktopOutlined,
  ContainerOutlined,
  MailOutlined,
  MenuOutlined,
  DashboardOutlined,
  PicLeftOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";

const { Header, Sider, Content } = Layout;

function Dashboard() {
  const navigate = useNavigate();

  const handleMenuClick = (e) => {
    navigate(e.key); // e.key will be your route path
  };

  process.env.NODE_ENV === "development"
    ? (document.title = "HS DEV MODE | Dashboard Overview")
    : (document.title = "Dashboard Overview | Hansoftware");

  const [settingsVisible, setSettingsVisible] = useState(false);
  const [visible, setVisible] = useState(false);

  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const modifiedObjects = [
    "Project Alpha",
    "Budget Report Q3",
    "Marketing Strategy",
    "UI Mockups",
  ];

  const upcomingEvents = [
    "Team Standup - Monday 9AM",
    "Client Presentation - Wednesday 2PM",
    "System Maintenance - Friday 10PM",
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
        <div
          style={{
            height: 32,
            margin: 16,
            color: "white",
            fontSize: 18,
            textAlign: "center",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {collapsed ? <MenuOutlined /> : "Menu"}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          onClick={handleMenuClick}
          defaultSelectedKeys={["/dashboard"]}
          items={[
            {
              key: "/dashboard",
              icon: <PieChartOutlined />,
              label: "Dashboard",
            },
            {
              key: "/dashboard/job-board",
              icon: <DashboardOutlined />,
              label: "Job Board",
            },
            {
              key: "/dashboard/ticket-generator",
              icon: <PicLeftOutlined />,
              label: "Ticket Generator",
            },
            {
              key: "/dashboard/customer-list",
              icon: <UnorderedListOutlined />,
              label: "Customer List",
            },
          ]}
        />
      </Sider>
      <Layout>
        <Header style={{ background: "#fff", padding: "0 20px" }}>
          <h1 style={{ margin: 0 }}>Dashboard Overview</h1>
        </Header>
        <Content style={{ padding: "24px" }}>
          <div
            style={{
              padding: 24,
              background: "#fff",
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 16,
            }}
          >
            <Card title="Upcoming jobs">
              <List
                dataSource={upcomingEvents}
                renderItem={(item) => <List.Item>{item}</List.Item>}
              />
            </Card>
            <Card
              title="Recently modified"
              styles={{
                body: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                },
              }}
            >
              <List
                dataSource={modifiedObjects}
                renderItem={(item) => <List.Item>{item}</List.Item>}
              />
            </Card>
            <Card title="Navigation">
              <List>
                <List.Item>
                  <a href="#/profile">Go to Profile</a>
                </List.Item>
                <List.Item>
                  <a href="#/settings">Open Settings</a>
                </List.Item>
                <List.Item>
                  <a href="#/analytics">View Analytics</a>
                </List.Item>
              </List>
            </Card>
          </div>
        </Content>
      </Layout>
    </Layout>

    //     Everything you need in one place
    //     Here you will find all of your most used programs, along
    //     with snippets of data to view at a glance.
    // <Button onClick={navigate("/")}>Home</Button>
    //   <Button
    //     onClick={() => {
    //       navigate("/dashboard/job-tickets");
    //     }}
    //   >
    //     Job Tickets
    //   </Button>
    //   <Button
    //     onClick={() => {
    //       navigate("/dashboard/customer-list");
    //     }}
    //   >
    //     Customer List
    //   </Button>
  );
}

export default Dashboard;
